import * as THREE from 'three'

export default class PlaneCube
{
    constructor (size, node, textureManager)
    {

        const matcapTex = textureManager.matcapTex
        const topGradientTex = textureManager.topGradientTex
        const alphaMapTex = textureManager.alphaMapTex
        const alphaMapTex2 = textureManager.alphaMapTex2

        const textureLoader = new THREE.TextureLoader()
        textureLoader.crossOrigin = "anonymous"
        let logo = null
        if (node.data.logo_to_attach != null) logo = textureLoader.load(node.data.logo_to_attach)

        this.opacity = 1
        this.cube = new THREE.Object3D()
        let planeGeom = null
        let plane = null
        this.planes = []

        this.materials = []

        const topGradientMat = new THREE.MeshBasicMaterial()
        topGradientMat.map = topGradientTex
        topGradientMat.color = new THREE.Color("white")
        topGradientMat.transparent = true
        topGradientMat.opacity = 0.8

        this.materials.push(topGradientMat)

        const matcapMat = new THREE.MeshMatcapMaterial();
        matcapMat.matcap = matcapTex
        matcapMat.alphaMap = alphaMapTex
        matcapMat.color = new THREE.Color(node.colorA)
        matcapMat.transparent = true
        matcapMat.opacity = 1

        this.materials.unshift(matcapMat)

        if (node.type == 'blockchain' || node.type == 'major_project' || node.type == 'customer_dapp') {
            const matcapMat2 = new THREE.MeshMatcapMaterial();
            matcapMat2.matcap = matcapTex
            matcapMat2.alphaMap = alphaMapTex2
            matcapMat2.color = new THREE.Color(node.colorB)
            matcapMat2.transparent = true
            matcapMat2.opacity = 1
            this.materials.unshift(matcapMat2)
        }

        const rotations = [[0,0,0], [0,Math.PI,0], [0,Math.PI*0.5,0], [0,Math.PI*1.5,0], [Math.PI*1.5,0,-Math.PI*0.5], [Math.PI*.5,0,0]]

        const positions = [[0,0,size*0.5], [0,0,-size*0.5], [size*0.5,0,0], [-size*0.5,0,0],
                    [0,size*0.5,0], [0,-size*0.5,0]]


        for (let i = 0; i < 6; i++) {
            for (let j = 0; j < this.materials.length; j++) { 
                planeGeom = new THREE.PlaneGeometry(size, size)
                const materialInstance = this.materials[j]
                plane = new THREE.Mesh(planeGeom, materialInstance)
                plane.position.setX(positions[i][0] * (1+0.002*j))
                plane.position.setY(positions[i][1] * (1+0.002*j))
                plane.position.setZ(positions[i][2] * (1+0.002*j))
                plane.rotateX(rotations[i][0])
                plane.rotateY(rotations[i][1])
                plane.rotateZ(rotations[i][2])
                this.planes.push(plane)
                this.cube.add(plane)
            }
        }

        if (logo) {
            planeGeom = new THREE.PlaneGeometry(size*0.4, size*0.4)
            const materialInstance = new THREE.MeshBasicMaterial
            plane = new THREE.Mesh(planeGeom, materialInstance)
            plane.position.setX(positions[0][0] * (1+0.002*this.materials.length))
            plane.position.setY(positions[0][1] * (1+0.002*this.materials.length))
            plane.position.setZ(positions[0][2] * (1+0.002*this.materials.length))
            plane.rotateX(rotations[0][0])
            plane.rotateY(rotations[0][1])
            plane.rotateZ(rotations[0][2])
            this.planes.push(plane)
            this.cube.add(plane)
            materialInstance.map = logo
            materialInstance.transparent = true
        }
        
    }

    disableLogo() {
        this.planes[this.planes.length - 1].visible = false
    }

    disableSecondMatcap() {
        this.materials[0].opacity = 0
    }

    show() {
        // const globalDelay =  Math.random() * 1
        // for (let index = 0; index <  this.planes.length; index++) {
        //     const delay = this.cube.parent.position.x * 0.3 + globalDelay
        //     const lineMat =  this.planes[index].material

        //     const previousX =  this.planes[index].rotation.x
        //     const previousY =  this.planes[index].rotation.y
        //     const previousZ =  this.planes[index].rotation.z
        //     //this.planes[index].rotation.set(-0.01*Math.random()*0.02,-0.01*Math.random()*0.02,-0.01*Math.random()*0.02)
        //     //gsap.to(this.planes[index].rotation, {x: previousX, y: previousY, z: previousZ, duration: 0.1*Math.random(), delay: delay, ease: 'power3.easeIn'})
        //     gsap.to(lineMat, {opacity: 0.0, duration: 0.01, delay: 0, ease: 'power3.easeIn'})
        //     gsap.to(lineMat, {opacity: this.opacity, duration: 0.3*Math.random(), delay: 0.01 + delay, ease: 'power3.easeIn'})
        // }
    }

    setOpacity(value) {
        this.opacity = value
    }

    setBlending(mode) {
        for (let index = 0; index <  this.planes.length; index++) {
            this.planes[index].material.blending = mode
        }
    }

    expand() {
        for (let index = 0; index <  this.planes.length; index++) {
            // let facePos = new THREE.Vector3(0,0,0)
            // this.planes[index].position.copy(facePos)
            // facePos.multiplyScalar(1)
            // this.planes[index].position.set(facePos.x, facePos.y, facePos.z)
        }
    }

}